module.exports = __webpack_public_path__ + "img/img-01.96e0ea17.jpg";